import { NumberInput, TextInput } from '@core/components/Inputs';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import RangeDateInput from '@core/components/Inputs/RangeDateInput';
import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Tooltip,
} from '@material-ui/core';
import { calcularValorComDesconto } from 'app/utils/monetarioUtil';
import { useFormikContext } from 'formik';
import React from 'react';

const getCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');

const TabDadosServico = () => {
  const formik = useFormikContext();

  const { errors, touched, submitCount } = formik;

  const _errors = {
    descricao: (submitCount || touched?.descricao) && errors?.descricao,
    descricaoDetalhada: (submitCount || touched?.descricaoDetalhada) && errors?.descricaoDetalhada,
    codigo: (submitCount || touched?.codigo) && errors?.codigo,
    tipo: (submitCount || touched?.tipo) && errors?.tipo,
    valorCusto: (submitCount || touched?.valorCusto) && errors?.valorCusto,
    valorVenda: (submitCount || touched?.valorVenda) && errors?.valorVenda,
    promocao: {
      vigenciaInicio: (submitCount || touched.promocao?.vigenciaInicio) && errors.promocao?.vigenciaInicio,
      valor: (submitCount || touched.promocao?.valor) && errors.promocao?.valor,
    },
  };

  const handleSetPromocao = (e) => {
    if (!formik.values.emPromocao) {
      formik.setFieldValue('promocao.tipo', 'VALOR');
    }

    formik.handleChange(e);
  };

  const valorComDesconto = calcularValorComDesconto(
    formik.values?.promocao?.tipo,
    formik.values?.valorVenda,
    formik.values?.promocao?.valor
  );

  return (
    <Grid container spacing={3} className="mt-16">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="descricao"
          name="descricao"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.descricao}
          error={_errors.descricao}
          touched={formik.touched.descricao}
          maxLength={50}
          required
          fullWidth
          autoFocus
          variant="outlined"
          label="Nome do serviço prestado"
        />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
        <Tooltip placement="top-start" title="Código de controle interno da sua empresa">
          <div>
            <TextInput
              id="codigo"
              name="codigo"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.codigo}
              error={_errors.codigo}
              required={formik.values?.id ? true : false}
              touched={formik.touched.codigo}
              maxLength={20}
              fullWidth
              variant="outlined"
              label="Código de identificação"
            />
          </div>
        </Tooltip>
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
        <CurrencyTextField
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="999999999"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={!!_errors.valorCusto}
          helperText={_errors.valorCusto || ''}
          onChange={(e, value) => {
            formik.setFieldValue('valorCusto', value);
          }}
          onBlur={formik.handleBlur}
          id="valorCusto"
          name="valorCusto"
          value={formik.values?.valorCusto}
          fullWidth
          variant="outlined"
          label="Valor de custo (R$)"
        />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
        <CurrencyTextField
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="999999999"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={!!_errors.valorVenda}
          helperText={_errors.valorVenda || ''}
          onChange={(e, value) => {
            formik.setFieldValue('valorVenda', value);
          }}
          onBlur={formik.handleBlur}
          id="valorVenda"
          name="valorVenda"
          value={formik.values?.valorVenda}
          fullWidth
          variant="outlined"
          label="Valor de venda (R$)"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="descricaoDetalhada"
          name="descricaoDetalhada"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.descricaoDetalhada}
          error={_errors.descricaoDetalhada}
          touched={formik.touched.descricaoDetalhada}
          required={!!_errors.descricaoDetalhada}
          maxLength={500}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          label="Descrição detalhada do serviço"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControlLabel
          control={
            <Switch
              id="emPromocao"
              name="emPromocao"
              value={formik.values?.emPromocao}
              checked={formik.values?.emPromocao}
              onChange={handleSetPromocao}
              onBlur={formik.handleBlur}
              color="primary"
            />
          }
          label="Serviço em promoção"
        />
      </Grid>
      {formik.values.emPromocao && (
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
            <RangeDateInput
              id="promocao.vigenciaInicio"
              name="promocao.vigenciaInicio"
              value={[formik.values.promocao?.vigenciaInicio, formik.values.promocao?.vigenciaFim]}
              label="Período de vigência *"
              error={!!_errors.promocao?.vigenciaInicio}
              helperText={_errors.promocao?.vigenciaInicio}
              onBlur={formik.handleBlur}
              onChange={(inicio, fim) => {
                formik.setFieldValue('promocao.vigenciaFim', fim);
                formik.setFieldValue('promocao.vigenciaInicio', inicio);
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
            <FormControl
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              style={{ width: '100%' }}
              error={!!_errors.tipo}
            >
              <InputLabel id="promocao.tipo">Tipo do desconto *</InputLabel>
              <Select
                id="promocao.tipo"
                name="promocao.tipo"
                value={formik.values?.promocao?.tipo}
                fullWidth
                label="Tipo do desconto *"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="VALOR">Valor (R$)</MenuItem>
                <MenuItem value="PERCENTUAL">Percentual (%)</MenuItem>
              </Select>
              <FormHelperText>{_errors?.promocao?.tipo || ''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
            {formik.values.promocao?.tipo === 'VALOR' ? (
              <CurrencyTextField
                outputFormat="number"
                decimalCharacter=","
                digitGroupSeparator="."
                maximumValue="999999999"
                decimalPlaces={2}
                decimalPlacesShownOnBlur={2}
                decimalPlacesShownOnFocus={2}
                error={!!_errors.promocao?.valor}
                helperText={_errors.promocao?.valor || ''}
                onChange={(e, value) => {
                  formik.setFieldValue('promocao.valor', value);
                }}
                onBlur={formik.handleBlur}
                id="promocao.valor"
                name="promocao.valor"
                value={formik.values?.promocao?.valor}
                required
                fullWidth
                variant="outlined"
                label="Desconto (R$)"
              />
            ) : (
              <NumberInput
                required
                label="Desconto (%)"
                id="promocao.valor"
                decimalScale={8}
                decimalSeparator=","
                allowNegative={false}
                isAllowed={(values) => {
                  return !values.floatValue || values.floatValue <= 100;
                }}
                value={formik.values.promocao?.valor}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                touched={formik.touched.promocao?.valor}
                error={formik.errors.promocao?.valor}
              />
            )}
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
            <ReadOnlyInput
              id="promocao.valorComDesconto"
              label="Valor com desconto(R$)"
              value={getCurrency(valorComDesconto)}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default TabDadosServico;
